import React from 'react';
import { Calendar, TrendingUp } from 'lucide-react';

const PortfolioProjections = ({ projections, isLoading, error, textColor }) => {
  // Default fallback values
  const fallbackProjection2030 = 4052000;
  const fallbackProjection2040 = 6800000;

  const formatProjection = (value) => {
    if (value === undefined || value === null) return 'N/A';
    return new Intl.NumberFormat('en-US', { 
      style: 'currency', 
      currency: 'USD',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(value);
  };

  const projection2030 = projections?.['2030'] !== undefined ? projections['2030'] : fallbackProjection2030;
  const projection2040 = projections?.['2040'] !== undefined ? projections['2040'] : fallbackProjection2040;

  return (
    <div className="flex-1 min-w-[200px] bg-gradient-to-br from-green-50 to-white p-3 rounded-lg shadow-sm border border-green-100">
      <h3 className="text-base font-medium mb-2" style={{ color: textColor || 'inherit' }}>
        Projections
      </h3>
      
      {isLoading ? (
        <div className="animate-pulse space-y-3">
          <div className="h-5 bg-gray-200 rounded w-3/4"></div>
          <div className="h-5 bg-gray-200 rounded w-1/2"></div>
        </div>
      ) : (
        <div className="space-y-3">
          <div>
            <div className="flex items-center gap-2">
              <div className="p-1.5 bg-green-100 rounded-full">
                <Calendar size={16} className="text-green-600" />
              </div>
              <div>
                <p className="text-xs text-gray-500" style={{ color: textColor ? `${textColor}99` : 'inherit' }}>
                  2030 Projection
                </p>
                <p className="text-lg font-semibold" style={{ color: textColor || 'inherit' }}>
                  {formatProjection(projection2030)}
                </p>
              </div>
            </div>
          </div>
          
          <div>
            <div className="flex items-center gap-2">
              <div className="p-1.5 bg-green-100 rounded-full">
                <TrendingUp size={16} className="text-green-600" />
              </div>
              <div>
                <p className="text-xs text-gray-500" style={{ color: textColor ? `${textColor}99` : 'inherit' }}>
                  2040 Projection
                </p>
                <p className="text-lg font-semibold" style={{ color: textColor || 'inherit' }}>
                  {formatProjection(projection2040)}
                </p>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PortfolioProjections;